import "./Monitoring.module.css";
import Header from "@/reusable_sections/Header";
import Monitoring from "./sections/Monitoring";
import Features from "./sections/Features";
import Process from "./sections/Process";
import ProductGallery from "./sections/ProductGallery";
import UseCases from "./sections/UseCases";
import Action from "./sections/Action";
import Footer from "@/reusable_sections/Footer";
export default function MonitoringPage() {
  return <div>
      <Header />
      <Monitoring />
      <Features />
      <Process />
      <ProductGallery />
      <UseCases />
      <Action />
      <Footer />
    </div>;
}